'use strict';

define('lib/transforms/slp.offer.comment',['lib/util/tda.config'], function (tdaConfig) {
  var __offerHostname = window.location.protocol + '//' + window.location.host;

  // Builds the hidden SLP form comment to be sent along to ELMS
  // Expects raw offer off of offerBundle from offers-service response
  return function slpOfferComment(offer) {
    var offerType;
    var offerVehicle;
    var offerYear;
    var offerSeries;
    var offerEndDate;
    var offerURL;
    var offerInfo;
    var offerRate;
    var offerDuration;
    var offerMonthlyPayment;
    var offerLeaseDuration;
    var offerDueAtSigning;
    var offerTitle;
    var offerDescription;
    var offerCashAmount;
    var subTypeLabels;

    if (!offer) {
      return null;
    }

    offerType = offer.offerType;
    offerYear = offer.seriesList.series.year;
    offerSeries = offer.seriesList.series.id;
    offerVehicle = offerYear + ' ' + offerSeries;
    offerEndDate = offer.endDate;
    offerURL = __offerHostname + '/' + tdaConfig.site.context_url + '/offer-detail/?offerid=' + offer.offerId;

    if (offerType === 'APR') {
      offerRate = offer.apr.tiers.tier[0].term[0].rate;
      offerDuration = offer.apr.tiers.tier[0].term[0].duration;
      offerInfo = offerRate + '% for ' + offerDuration + ' Months';
    }

    if (offerType === 'Lease') {
      offerMonthlyPayment = offer.lease.tiers.tier[0].term[0].monthlyPayment;
      offerLeaseDuration = offer.lease.tiers.tier[0].term[0].duration;
      offerDueAtSigning = offer.lease.tiers.tier[0].term[0].dueAtSigningAmount;
      offerInfo = '$' + offerMonthlyPayment + ' for ' + offerLeaseDuration + ' Months, $' + offerDueAtSigning + ' Due at Signing';
    }

    if (offerType === 'Miscellaneous') {
      offerTitle = offer.title;
      offerDescription = offer.description;
      offerInfo = offerTitle + '. ' + offerDescription + '.';
    }

    if (offerType === 'Cash') {
      offerCashAmount = offer.cash.cashAmount;
      subTypeLabels = offer.cash.subTypeLabels;
      offerInfo = '$' + offerCashAmount + ' ' + subTypeLabels;
    }

    if (offerType === 'Multiple_Vehicle') {
      offerCashAmount = offer.multivehicle.cashAmount;
      subTypeLabels = offer.multivehicle.subTypeLabels;
      offerType = 'Cash';
      offerVehicle = 'Multi';
      offerInfo = '$' + offerCashAmount + ' ' + subTypeLabels;
    }

    var commentInfo = 'Offer Type: ' + offerType + ' | ';
    if (offerVehicle !== 'Multi' && offerType !== 'Miscellaneous') {
      commentInfo += 'Vehicle: ' + offerVehicle + ' | ';
    }
    commentInfo += 'Offer Info: ' + offerInfo + ' | ';
    commentInfo += 'Offer End Date: ' + offerEndDate + ' | ';
    commentInfo += 'Offer URL: ' + offerURL;

    return commentInfo;
  };
});

